let idCounter = 0;

export const generateId = (prefix: string = 'field'): string => {
  return `${prefix}-${++idCounter}`;
};
